import { setupAccordions } from '$c3base/accordion.js';

$(function () {
    setupAccordions('.accordion');
});

$(window).on('load', function (e) {

});

$(window).on('resize', function (e) {

});

